export const FINAL_SALE_COPY = 'Final Sale - Not Eligible for Return';
export const FINAL_SALE_SHORT_COPY = 'Final Sale - Item is not returnable.';
export const FINAL_SALE_SHORT_COPY_PLURAL = 'Final Sale - These items are not returnable.';
